import ImageComponent from "@/components/ui/ImageComponent"
import { Button } from "@heroui/react"
import { TreatmentLink } from "@/components/ui/TreatmentLink"
import { GoArrowUpRight } from "react-icons/go"

export interface TransformDetailCardProps {
    url: string
    alt_name: string
    heading: string
    description: string
    slug:string
}

const TransformDetailCard = ({ url, alt_name, heading, description,slug }: TransformDetailCardProps) => {


    return (
        <TreatmentLink slug={slug} className="space-y-6 px-0 md:px-2 overflow-hidden">

            <div className="h-[220px] md:h-[390px] w-auto rounded-[7.94px] md:rounded-3xl overflow-hidden">
                <ImageComponent url={url} img_title={alt_name} object_cover={true} />
            </div>

            <div className="flex justify-between items-center">
                <div className="space-y-1 w-[80%]">
                    <h3 className="font-semibold text-[13px] md:text-base tracking-[6%] uppercase line-clamp-1">
                        {heading}
                    </h3>
                    <p className="text-[11px] md:text-sm text-textf2 line-clamp-2">
                        {description}
                    </p>
                </div>
                <Button
                    aria-label="Next"
                    endContent={<GoArrowUpRight className="text-lightBrown text-xs md:text-xl font-extrabold" />}
                    className="border-1 border-lightBrown rounded-full btn_global icon_button_forward pointer-events-auto shrink-0"
                />

            </div>
        </TreatmentLink>
    )
}

export default TransformDetailCard
